import { lenisScroll } from './modules/lenis.js';
import { navigation } from './modules/navigation.js';
import { headerScroll } from './modules/headerScroll.js';
import { wysiwygHeadings } from './modules/wysiwygHeadings.js';
// import { accordion } from './modules/accordion.js';
import { storeGallery } from './modules/storeGallery.js';
import { startHero } from './modules/startHero.js';
import { thankYouConfetti } from './modules/thankYouConfetti.js';

lenisScroll();
navigation();
headerScroll();
wysiwygHeadings();
// accordion();
storeGallery();
startHero();
thankYouConfetti();
